const SIGNED_OUT_COOKIE = "momento_signed_out";
const SIGNED_OUT_SEEN_KEY = "momento_sign_out_seen";

function cookieDomains(hostname: string): string[] {
  const parts = hostname.split(".").filter(Boolean);
  const domains = new Set<string>();
  for (let i = 0; i < parts.length - 1; i += 1) {
    const host = parts.slice(i).join(".");
    domains.add(host);
    domains.add(`.${host}`);
  }
  return [...domains];
}

function expireCookie(name: string, domain?: string): void {
  const base = `${name}=; Max-Age=0; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
  document.cookie = domain ? `${base}; domain=${domain}` : base;
}

/** Drop cookies, saved seats, and other fan data stored for this Momento site. */
export function clearMomentoSiteData(): void {
  try {
    const names = document.cookie
      .split(";")
      .map((part) => part.split("=")[0].trim())
      .filter(Boolean);
    const domains = cookieDomains(window.location.hostname);
    names.forEach((name) => {
      expireCookie(name);
      domains.forEach((domain) => expireCookie(name, domain));
    });
  } catch {
    /* ignore */
  }
  try {
    localStorage.clear();
  } catch {
    /* ignore */
  }
  try {
    sessionStorage.clear();
  } catch {
    /* ignore */
  }
}

function readCookie(name: string): string {
  const prefix = `${name}=`;
  const part = document.cookie.split(";").map((item) => item.trim()).find((item) => item.startsWith(prefix));
  if (!part) return "";
  try {
    return decodeURIComponent(part.slice(prefix.length));
  } catch {
    return part.slice(prefix.length);
  }
}

function writeSignOutCookie(stamp: string): void {
  const host = window.location.hostname;
  const shared = host === "mymomento.com" || host.endsWith(".mymomento.com");
  const domain = shared ? "; domain=.mymomento.com" : "";
  document.cookie = `${SIGNED_OUT_COOKIE}=${encodeURIComponent(stamp)}; Max-Age=86400; path=/; SameSite=Lax${domain}`;
}

/** Stamp from another Momento hostname that this site has not cleared yet. */
export function pendingMomentoSignOutStamp(): string | null {
  try {
    const stamp = readCookie(SIGNED_OUT_COOKIE);
    if (!stamp) return null;
    if (localStorage.getItem(SIGNED_OUT_SEEN_KEY) === stamp) return null;
    return stamp;
  } catch {
    return null;
  }
}

/** Remember this sign-out on .mymomento.com so other team sites clear saved seats too. */
export function rememberMomentoSignOutStamp(stamp: string): void {
  try {
    writeSignOutCookie(stamp);
    localStorage.setItem(SIGNED_OUT_SEEN_KEY, stamp);
  } catch {
    /* ignore */
  }
}
